<template>
  <div class="undo-redo-controls">
    <button
      @click="undo"
      :class="{ disabled: !canUndo }"
    >
      undo
    </button>
    <button
      @click="redo"
      :class="{ disabled: !canRedo }"
    >
      redo
    </button>
  </div>
</template>

<script>
export default {
  props: {
    namespace: {
      type: String,
      required: true
    }
  },
  methods: {
    undo() {
      this.$store.dispatch("undo/undo", { namespace: this.namespace });
    },
    redo() {
      this.$store.dispatch("undo/redo", { namespace: this.namespace });
    }
  },
  computed: {
    canUndo() {
      return this.$store.getters["undo/canUndo"](this.namespace);
    },
    canRedo() {
      return this.$store.getters["undo/canRedo"](this.namespace);
    }
  }
};
</script>

<style>
.undo-redo-controls {
  position: absolute;
  width: 550px;
  top: -30px;
  text-align: center;
}

.undo-redo-controls button {
  margin: 0 10px;
  padding: 2px 5px;
  border: 1px solid rgba(175, 47, 47, 0.15);
  border-radius: 5px;
  text-transform: capitalize;
}

.undo-redo-controls button.disabled {
  opacity: 0.6;
}

.undo-redo-controls button:hover {
  background-color: rgba(175, 47, 47, 0.15);
}

.undo-redo-controls button.disabled:hover {
  background-color: transparent;
}

.undo-redo-controls button:active {
  background-color: rgba(24, 12, 12, 0.29);
}

.undo-redo-controls button.disabled:active {
  background-color: transparent;
}
</style>
